import React from "react";
import PrintsGrid from "../components/Prints/PrintsGrid";

interface Props {
  Title: string;
}

interface State {
  data: any;
}

class Prints extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentDidMount(): void {}

  render() {
    return (
      <div className="wrapper">
        <div className="section latest-offers">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <PrintsGrid
              key={"PrintsGrid"}
              Title={"Print Values"}
              MaxRows={100}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Prints;
